module.exports = __webpack_public_path__ + "static/media/apply-thank-img-mob.06556d7e.png";